import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Salad, Package, Coins, Box, SlidersHorizontal } from "lucide-react";

import css from "./TitleMenuSettings.module.css";
import { getTitleMenuSettings } from "../../../helpers";
import { useRoleAccess } from "../../../hooks/useRoleAccess";

const GROUP_ICONS = {
  "ti-salad": Salad,
  "ti-package": Package,
  "ti-coin": Coins,
  "ti-box": Box,
  "ti-adjustments": SlidersHorizontal,
};

const TitleMenuSettings = () => {
  const { t } = useTranslation();
  const { userRole } = useRoleAccess();
  const location = useLocation();
  const navigate = useNavigate();

  const groups = getTitleMenuSettings(t, userRole).filter(
    (g) => g.allowedRoles
  );

  const activeGroup = useMemo(() => {
    const segment = location.pathname.split("/settings/")[1]?.split("/")[0];
    return (
      groups.find((g) => g.items.some((item) => item.linkForRoute === segment))
        ?.groupKey ?? groups[0]?.groupKey
    );
  }, [location.pathname, groups]);

  const currentGroup = groups.find((g) => g.groupKey === activeGroup);
  const visibleItems = (currentGroup?.items ?? []).filter(
    (item) => item.allowedRoles
  );

  return (
    <nav className={css.wrap}>
      <div className={css.groupBar}>
        {groups.map((group) => (
          <button
            key={group.groupKey}
            className={`${css.groupTab} ${
              activeGroup === group.groupKey ? css.groupTabActive : ""
            }`}
            onClick={() => {
              const firstItem = group.items.find((i) => i.allowedRoles);
              if (firstItem) {
                navigate(`/settings/${firstItem.linkForRoute}`);
              }
            }}
          >
            {(() => { const Icon = GROUP_ICONS[group.icon]; return Icon ? <Icon size={17} aria-hidden="true" className={css.groupIcon} /> : null; })()}
            <span>{group.groupLabel}</span>
          </button>
        ))}
      </div>

      <div className={css.subBar}>
        {visibleItems.map((item) => (
          <NavLink
            key={item.linkForRoute}
            to={`/settings/${item.linkForRoute}`}
            className={({ isActive }) =>
              `${css.subPill} ${isActive ? css.subPillActive : ""}`
            }
          >
            {item.name}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export { TitleMenuSettings };
